import { type Credential } from '@iichi/domain/member';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useUserCredentialStore = defineStore('userCredential', () => {
  const credentialsArr = ref<Credential[]>([]);
  const hasCredential = computed(() => (credential: Credential) => credentialsArr.value.includes(credential));

  function updateCredential(credentials: Credential[]) {
    credentials.forEach((credential) => {
      if (!credentialsArr.value.includes(credential)) {
        credentialsArr.value.push(credential);
      }
    });
  }

  function resetCredential() {
    credentialsArr.value = [];
  }

  return { hasCredential, updateCredential, resetCredential };
});
